import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import messageHandler from 'utils/messageHandler';
import { uploadRealEstateLogo, getRealEstateData } from 'redux/realEstateSlice';
import { useDispatch, useSelector } from 'react-redux';
import { UploadPhoto } from '../../../../../components/common/UploadPhoto';
import { getImageUrl } from 'utils/imageUrl';

const generateProfile = realEstate => {
  const name = realEstate?.name?.split(' ');
  if (name) {
    if (name?.length === 1) {
      return `${name[0]?.slice(0, 1)?.toUpperCase()}`;
    }

    return `${name[0]?.slice(0, 1)?.toUpperCase()}${name[1]
      ?.slice(0, 1)
      ?.toUpperCase()}`;
  }
};

const ChangeLogo = () => {
  const [loading, setLoading] = useState(true);
  const realEstate = useSelector(state => state.realEstate.data);
  const dispatch = useDispatch();

  useEffect(() => {
    if (realEstate?.name || realEstate?.logo) {
      setLoading(false);
    }
  }, [realEstate]);

  const handleUploadImage = async file => {
    setLoading(true);
    const newImage = file;
    let formData = new FormData();
    formData.append('photo', newImage);
    try {
      const response = await dispatch(
        uploadRealEstateLogo(realEstate.id, formData)
      );

      if (response?.data && response.status === 200) {
        messageHandler(
          'success',
          'El logo de la inmobiliaria fue actualizado correctamente.'
        );
        await dispatch(getRealEstateData(realEstate.id));
      }
    } catch (e) {
      messageHandler(
        'error',
        'Hubo un error cargando la imágen. Por favor, intente nuevamente.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="bg-white">
      <Card.Header className="border-bottom">
        <Card.Title>Logo de la Inmobiliaria</Card.Title>
      </Card.Header>

      <Card.Body>
        <Row>
          <Col>
            <div
              className="w-100 h-100 position-relative d-flex justify-content-center align-items-center"
              style={{ aspectRatio: '1/1' }}
            >
              {loading ? (
                <Spinner
                  animation="border"
                  style={{
                    color: '#2c7be5'
                  }}
                />
              ) : realEstate?.logo ? (
                <img
                  src={getImageUrl(
                    realEstate.logo,
                    'realestate',
                    realEstate.id
                  )}
                  alt="Logo de la inmobiliaria"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                  className="rounded"
                />
              ) : (
                <div className="real-estate-initials">
                  {generateProfile(realEstate)}
                </div>
              )}

              <UploadPhoto handleUploadImage={handleUploadImage} />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ChangeLogo;
